export default "__VITE_ASSET__Dxe_z7g___"